import React from 'react';
import styledComponents from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton
} from "@mui/material";

import { red } from '@mui/material/colors';

import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Blogs = ({ blogData }) => {
  const navigate = useNavigate();
  const hari = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const bulan = ['Januari', 'Februari', 'Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];
  return (
    <Container>
      <Grid container>
        <Grid item xs={12} sx={{ paddingY: '20px' }}>
          <Typography variant="h5" color="gray">
            BLOG WNJ
          </Typography>
        </Grid>
        {blogData.map((row) => (
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{ paddingX: '10px', paddingY: '15px' }}>
            <Card>
              <CardHeader
                avatar={
                  <Avatar
                    sx={{
                      bgcolor: red[500],
                      width: { xs: '20px', md: '25px', lg: '35px' },
                      height: { xs: '20px', md: '25px', lg: '35px' }
                    }}
                    aria-label="recipe"
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: '9px', sm: '11px', lg: '16px' }
                      }}
                    >
                      {row.author.substring(0,2).toUpperCase()}
                    </Typography>
                  </Avatar>
                }
                subheader={
                  <Typography
                    sx={{
                      fontSize: { xs: '12px', lg: '16px' }
                    }}
                    variant="subtitle2"
                  >
                    {`${hari[new Date(row.created_at).getDay()]}, ${new Date(row.created_at).getDate()} ${bulan[new Date(row.created_at).getMonth()]} ${new Date(row.created_at).getFullYear()}`}
                  </Typography>
                }
                sx={{
                  padding: { xs: '7px', md: '10px', lg: '16px' }
                }}
              />
              <CardMedia
                component="img"
                image={`${process.env.REACT_APP_ADMIN_URL}${row.gambar}`}
                sx={{ height: { xs: '260px', md: '240px', lg: '260px' } }}
              />
              <CardContent
                sx={{ 
                  height: { xs: '140px', sm: '170px', md: '120px', lg: '180px', xl: '150px' }
                }}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    paddingX: { xs: '7px', md: '10px', lg: '16px' },
                    fontSize: { xs: '14px', lg: '17px' },
                    fontWeight: 700
                  }}
                >
                  {row.judul}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  component="div"
                  sx={{
                    paddingX: { xs: '7px', md: '16px' },
                    fontSize: { xs: '14px', md: '16px' }
                  }}
                >
                  <Grid container sx={{ display: { xs: 'block', sm: 'none', md: 'none' } }}>
                    <div
                      dangerouslySetInnerHTML={{__html: row.isi.substring(0,180)}}
                    />
                    ...
                  </Grid>
                  <Grid container sx={{ display: { xs: 'none', sm: 'block', md: 'none' } }}>
                    <div
                      dangerouslySetInnerHTML={{__html: row.isi.substring(0,180)}}
                    />
                    ...
                  </Grid>
                  <Grid container sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                    <div
                      dangerouslySetInnerHTML={{__html: row.isi.substring(0,120)}}
                    />
                    ...
                  </Grid>
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'flex-end' }}>
                <IconButton aria-label="add to favorites">
                  <FavoriteIcon
                    sx={{
                      fontSize: { xs: '20px', sm: '22px', md: '24px', lg: '26px' }
                    }}
                  />
                </IconButton>
                <IconButton aria-label="share">
                  <ShareIcon
                    sx={{
                      fontSize: { xs: '20px', sm: '22px', md: '24px', lg: '26px' }
                    }}
                  />
                </IconButton>
                <IconButton onClick={() => navigate(`/blog/${row.idblog}`)} aria-label="share">
                  <VisibilityIcon
                    sx={{
                      fontSize: { xs: '20px', sm: '22px', md: '24px', lg: '26px' }
                    }}
                  />
                </IconButton>
                {/* <Button onClick={() => navigate(`/blog/${row.idblog}`)} size="small">Read More</Button> */}
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
};

export default Blogs;
